import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import BtnStandard from './BtnStandard';
import VideoStreamItem from './VideoStreamItem';

const today = new Date();
const twoWeeksAgo = new Date(today);
twoWeeksAgo.setDate(today.getDate() - 14);

const ServerClean = ({ onSubmit }) => {
    const [dateOnly, setDateOnly] = useState(twoWeeksAgo.toISOString().split('T')[0]); // format "YYYY-MM-DD"
    const [load, setLoad] = useState(false);
    const { mapUrl } = useContext(AppContext)
    const [streams, setStreams] = useState(null)
    const [streamSelect, setStreamSelect] = useState("")
    const [tableVideo, setTableVideo] = useState(null)
    const typeLabels = {
        statusServer: "Standard",
        statusServerPremium: "Premium",
        statusServerHide: "Hide",
    }

    const init = async () => {
        const response = await axios.get(mapUrl.stat_server_stream);
        if (response.data) {
            const grouped = Object.keys(response.data)
                .filter(k => typeLabels[k])
                .map(type => ({
                    type,
                    label: typeLabels[type],
                    servers: Object.values(response.data[type] || {})
                }))
                .filter(g => g.servers.length > 0)

            const first = grouped[0]?.servers[0]
            if (first) setStreamSelect(first.key)
            setStreams(grouped)
        }
    }

    const sortByLastWatchOldestFirst = (a, b) => {
        const parseDate = (d) => (d ? new Date(d).getTime() : NaN);
        const ta = parseDate(a.last_watch);
        const tb = parseDate(b.last_watch);

        // Place les valeurs invalides/null à la fin
        if (isNaN(ta) && isNaN(tb)) return 0;
        if (isNaN(ta)) return 1;
        if (isNaN(tb)) return -1;

        return ta - tb; // plus petit (ancien) d'abord
    };


    const toSqlDateTime = (yyyyMmDd) => {
        const [y, m, d] = yyyyMmDd.split('-').map(Number);
        const jsDate = new Date(y, m - 1, d, 0, 0, 0); // minuit local
        return jsDate.toISOString().slice(0, 19).replace('T', ' ');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!dateOnly) return;

        initSearch()
    };

    const typeMap = {
        statusServer: "standard",
        statusServerPremium: "premium",
        statusServerHide: "hide",
    }

    const getType = () => {
        const group = streams?.find(g => g.servers.some(s => s.key === streamSelect))
        return group ? typeMap[group.type] : "standard"
    }

    const initSearch = async () => {
        const selected = toSqlDateTime(dateOnly);
        const response = await axios.get(
            mapUrl.list_video_expire_orchestrator
                .replace("${server}", streamSelect)
                .replace("${date}", selected)
                .replace("${type}", getType())
        )
        const sorted = [...(response?.data || [])].sort(sortByLastWatchOldestFirst);
        setTableVideo(sorted);
    }

    useEffect(() => {
        init();
    }, [])

    return (
        <div className='flex1 cw fr py2 df fdc'>
            <div className="df fdc gap1 py2">
                {streams?.length > 0 && streams.map((group, gi) => (
                    <div key={`group-${group.type}`} className='df fdc'>
                        <p className='fb cs fs12 mb1' style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}>{group.label}</p>
                        <div className='df aic gap1 oxs'>
                            {group.servers.map((b, i) => (
                                <button
                                    onClick={() => setStreamSelect(b.key)}
                                    className={`card carder cw ${b.key == streamSelect ? "active" : ""}`}
                                    key={`server-stream-${gi}-${i}`}
                                >
                                    {b.key}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="df aic jcdb mb2 w100">
                <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 8, alignItems: 'center' }} >
                    <label htmlFor="cutoff">Date :</label>
                    <input
                        id="cutoff"
                        type="date"
                        className='input-date-time'
                        value={dateOnly}
                        onChange={(e) => setDateOnly(e.target.value)}
                        required
                    />
                    <div>
                        <BtnStandard load={load} label={"Valider"} size='m' click={() => { }} />
                    </div>
                </form>

                <p>{tableVideo?.length > 0 ? tableVideo.length : 0}</p>
            </div>
            {tableVideo?.length > 0 && (
                <div className="table-list-video">
                    <VideoStreamItem data={tableVideo} type={getType()} reset={() => initSearch()} />
                </div>
            )}
        </div>
    );
};

export default ServerClean;